import hrmService from '@/services/hrmService'

const state = {
  addressInfoList: [],
  currentAddressInfo: null,
  loading: false,
  error: null
}

const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_ADDRESS_INFO_LIST(state, list) {
    state.addressInfoList = list
  },
  SET_CURRENT_ADDRESS_INFO(state, info) {
    state.currentAddressInfo = info
  },
  ADD_ADDRESS_INFO(state, info) {
    state.addressInfoList.push(info)
  },
  UPDATE_ADDRESS_INFO(state, updatedInfo) {
    const index = state.addressInfoList.findIndex(item => item.id === updatedInfo.id)
    if (index !== -1) {
      state.addressInfoList.splice(index, 1, updatedInfo)
    }
  },
  REMOVE_ADDRESS_INFO(state, id) {
    state.addressInfoList = state.addressInfoList.filter(item => item.id !== id)
  }
}

const actions = {
  async fetchAddressInfoList({ commit }, params = {}) {
    try {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      const response = await hrmService.getAddressInfoList(params)
      if (response.success) {
        commit('SET_ADDRESS_INFO_LIST', response.data.data || [])
      } else {
        commit('SET_ERROR', response.message)
      }
      return response
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchAddressInfoById({ commit }, id) {
    try {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      const response = await hrmService.getAddressInfoById(id)
      if (response.success) {
        commit('SET_CURRENT_ADDRESS_INFO', response.data)
      } else {
        commit('SET_ERROR', response.message)
      }
      return response
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchAddressInfoByEmployee({ commit }, employeeId) {
    try {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      const response = await hrmService.getAddressInfoByEmployee(employeeId)
      if (response.success) {
        commit('SET_CURRENT_ADDRESS_INFO', response.data)
      } else {
        commit('SET_ERROR', response.message)
      }
      return response
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async saveAddressInfo({ commit }, addressData) {
    try {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      const response = await hrmService.saveAddressInfo(addressData)
      if (response.success) {
        if (addressData.id) {
          commit('UPDATE_ADDRESS_INFO', response.data)
        } else {
          commit('ADD_ADDRESS_INFO', response.data)
        }
      } else {
        commit('SET_ERROR', response.message)
      }
      return response
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async saveEmployeeAddressInfo({ commit }, { employeeId, addressData }) {
    try {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      const response = await hrmService.saveEmployeeAddressInfo(employeeId, addressData)
      if (response.success) {
        commit('SET_CURRENT_ADDRESS_INFO', response.data)
      } else {
        commit('SET_ERROR', response.message)
      }
      return response
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateAddressInfo({ commit }, { id, addressData }) {
    try {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      const response = await hrmService.updateAddressInfo(id, addressData)
      if (response.success) {
        commit('UPDATE_ADDRESS_INFO', response.data)
      } else {
        commit('SET_ERROR', response.message)
      }
      return response
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deleteAddressInfo({ commit }, id) {
    try {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      const response = await hrmService.deleteAddressInfo(id)
      if (response.success) {
        commit('REMOVE_ADDRESS_INFO', id)
      } else {
        commit('SET_ERROR', response.message)
      }
      return response
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

const getters = {
  addressInfoList: state => state.addressInfoList,
  currentAddressInfo: state => state.currentAddressInfo,
  loading: state => state.loading,
  error: state => state.error
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
